import { Alert, Button, Card, Grid, Image, Modal } from '@mantine/core';
import { IconAlertTriangle, IconCrown } from '@tabler/icons-react';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { v4 as uuidv4 } from 'uuid';
import prettifiedLabel from '../../constants/labelPrettifier';
import ConfirmationModal from '../Modals/ConfirmationModal';
import StripoTemplatesFilter from './StripoTemplatesFilter';

const StripoGallery = ({ templates, filterOptions, currentFilters, onFilterChange, close }) => {
  const { accountId, domainId, emailId } = useParams();
  const navigate = useNavigate();

  const [template, setTemplate] = useState(null);
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const baseEmailUrl = `/accounts/${accountId}/domains/${domainId}/emails/`;
  const emailPath = emailId ? `${emailId}/details` : 'new';
  const url = `${baseEmailUrl}${emailPath}?editor=stripo&tab=generalEmails&templateId=${template?.templateId}`;

  const handleCardClick = (template) => {
    setShowTemplateModal(true);
    setTemplate(template);
  };

  const templateModal = (
    <Modal
      opened={showTemplateModal}
      onClose={() => setShowTemplateModal(false)}
      size="lg"
      className="vh-100"
      title={
        <>
          {template?.premium ? <IconCrown size={14} /> : null}{' '}
          {template?.hasAmp ? prettifiedLabel('Dynamic template: ') : null}
          {prettifiedLabel(template?.name)}
        </>
      }
    >
      <Grid justify="center" mb="md">
        <Grid.Col span="auto" style={{ textAlign: 'center' }}>
          <Image src={template?.logo} fit="contain" radius="sm" />
        </Grid.Col>
      </Grid>
      <Grid justify="center" mb="md">
        <Grid.Col span={{ base: 12 }}>
          <Alert color="yellow" icon={<IconAlertTriangle size={14} />}>
            <strong>
              Ensure that the template contains accurate links. Please verify all links, update any incorrect ones, and
              remove any placeholder links.
            </strong>
          </Alert>
        </Grid.Col>
      </Grid>
      <Grid justify="center">
        <Grid.Col span="auto" style={{ textAlign: 'center' }}>
          <Button
            onClick={() => {
              if (emailId) {
                setConfirmModalOpen(true);
              } else {
                if (typeof close === 'function') {
                  close();
                }
                navigate(url);
              }
              setShowTemplateModal(false);
            }}
          >
            Use Template
          </Button>
        </Grid.Col>
      </Grid>
    </Modal>
  );

  return (
    <>
      <ConfirmationModal
        show={confirmModalOpen}
        close={() => {
          setConfirmModalOpen(false);
        }}
        confirm={() => {
          close();
          navigate(url);
        }}
        message="Are you sure you want to proceed? This action will overwrite any saved changes to your email."
      />
      {template && templateModal}
      <Card mb="lg" withBorder>
        <Card.Section inheritPadding py="sm">
          <StripoTemplatesFilter
            filterOptions={filterOptions}
            currentFilters={currentFilters}
            onFilterChange={onFilterChange}
          />
        </Card.Section>
      </Card>

      <Grid>
        {templates.map((template) => (
          <Grid.Col span={{ base: 12, sm: 6, md: 4, lg: 3 }} key={uuidv4()} mb="lg">
            <Card ta="center" onClick={() => handleCardClick(template)} style={{ cursor: 'pointer' }} withBorder>
              <Card.Section>
                <Image src={template?.logo} alt={template?.name} />
              </Card.Section>
              <Card.Section inheritPadding py="sm">
                <strong>
                  {template?.premium ? <IconCrown size={14} /> : null} {template?.name}
                </strong>
              </Card.Section>
            </Card>
          </Grid.Col>
        ))}
      </Grid>
    </>
  );
};

export default StripoGallery;
